module.exports = "/_next/static/images/406ca36ff5bd5ee26b0770d35635b834-rewards-smiles@3x.png";